import axios from "axios";
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}/api`;

const axiosClient = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.response.use(
  response => response,

  error => {
    console.error("API Error:", error);

    return Promise.reject(error);
  }
);

export default axiosClient;